import React from "react";
import { Link } from "react-router-dom";

export default function LandingV2Page() {
  return (
    <div
      data-testid="landing-v2-page"
      style={{
        minHeight: "100vh",
        background: "#FBF6EF",
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
        color: "#210875",
        overflowX: "hidden",
      }}
    >
      {/* ============ NAV ============ */}
      <nav style={{ padding: "20px 24px", display: "flex", justifyContent: "space-between", alignItems: "center", maxWidth: 1180, margin: "0 auto" }}>
        <span style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontWeight: 800, fontSize: 22, color: "#210875" }}>
          Biz360 <span style={{ fontSize: 18 }}>❤️‍🔥</span>
        </span>
        <div style={{ display: "flex", gap: 20, alignItems: "center", fontSize: 14 }}>
          <Link to="/login" style={{ color: "#210875", textDecoration: "none", fontWeight: 500 }}>Connexion</Link>
          <Link to="/subscription" style={{ background: "#210875", color: "#fff", padding: "10px 20px", borderRadius: 999, textDecoration: "none", fontWeight: 600, fontSize: 14 }}>Rejoindre →</Link>
        </div>
      </nav>

      {/* ============ HERO ============ */}
      <section style={{ maxWidth: 1000, margin: "0 auto", padding: "60px 24px 80px", textAlign: "center" }}>
        <p style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: 13, letterSpacing: "0.15em", textTransform: "uppercase", color: "#897FCB", fontWeight: 600, margin: "0 0 24px" }}>
          Pour toi qui bosses seule chez toi
        </p>
        <h1 style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: 52, lineHeight: 1.05, fontWeight: 800, letterSpacing: "-0.03em", margin: "0 0 24px", color: "#210875" }}>
          T'es seule<br/>
          face à ta compta.<br/>
          <span style={{ color: "#E8A87C" }}>Moi aussi, avant.</span>
        </h1>
        <p style={{ fontSize: 20, lineHeight: 1.5, color: "#3a2e6b", maxWidth: 640, margin: "0 auto 40px", fontWeight: 400 }}>
          Je suis Tiphaine, auto-entrepreneure comme toi. J'ai passé 2 ans à galérer avec Excel, à paniquer avant chaque déclaration, à payer un comptable pour 3 questions par an. Alors <strong>j'ai construit l'outil qui me manquait.</strong>
        </p>
        <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap", marginBottom: 20 }}>
          <Link to="/subscription" data-testid="hero-cta-main" style={{ background: "#210875", color: "#fff", padding: "18px 34px", borderRadius: 14, textDecoration: "none", fontFamily: "'Plus Jakarta Sans', sans-serif", fontWeight: 800, fontSize: 17 }}>
            Essayer 30 jours gratuits →
          </Link>
        </div>
        <p style={{ fontSize: 13, color: "#897FCB", margin: 0 }}>
          Sans CB · Sans engagement · Ensuite 12€/mois si tu restes
        </p>
      </section>

      {/* ============ RECONNAIS-TOI ============ */}
      <section style={{ background: "#fff", padding: "80px 24px" }}>
        <div style={{ maxWidth: 780, margin: "0 auto" }}>
          <p style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: 13, letterSpacing: "0.15em", textTransform: "uppercase", color: "#897FCB", fontWeight: 600, margin: "0 0 16px", textAlign: "center" }}>
            Dis-moi si tu te reconnais
          </p>
          <h2 style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: 36, lineHeight: 1.15, fontWeight: 800, letterSpacing: "-0.02em", margin: "0 0 48px", textAlign: "center" }}>
            La solitude de l'auto-entrepreneure,<br/>
            <span style={{ color: "#E8A87C" }}>ça ressemble souvent à ça</span> :
          </h2>
          <div style={{ display: "grid", gap: 20 }}>
            {[
              { emo: "😰", txt: "Dimanche soir, 22h. Tu regardes ton relevé bancaire. Tu essaies de comprendre combien tu vas devoir à l'Urssaf. Tu bidouilles Excel. Ça marche pas. Tu vas dormir angoissée." },
              { emo: "🤯", txt: "Tu ouvres autoentrepreneur.urssaf.fr. 47 champs à remplir. Aucune idée de quoi mettre où. Ton comptable met 3 jours à répondre à un mail simple. À 90€ le mail." },
              { emo: "😤", txt: "Tu vois passer « e-facturation obligatoire en 2027 » sur LinkedIn. Tu ne comprends rien. Tu scrolles. Tu paniqueras plus tard. Sauf que « plus tard » c'est bientôt." },
              { emo: "😔", txt: "Tu bosses seule dans ton salon. Personne à qui demander « c'est normal ça ? ». Ton mec/ta mère/ta pote n'a pas ton statut et ne peut pas t'aider. T'es toute seule avec tes doutes." },
              { emo: "💸", txt: "Tu payes ton comptable 400-800€/an pour 3 questions basiques. Tu te dis à chaque fois « je devrais me passer de lui »… mais tu n'oses pas parce que tu as peur de rater un truc." },
              { emo: "😬", txt: "T'as un doute sur ton seuil TVA. Tu tapes « seuil TVA auto-entrepreneur 2026 » sur Google. 15 articles contradictoires. Tu abandonnes." },
            ].map((item, i) => (
              <div key={i} style={{ background: "#FBF6EF", padding: "22px 24px", borderRadius: 14, display: "flex", gap: 18, alignItems: "flex-start" }}>
                <span style={{ fontSize: 28, flex: "0 0 auto" }}>{item.emo}</span>
                <p style={{ margin: 0, fontSize: 16, lineHeight: 1.55, color: "#3a2e6b" }}>{item.txt}</p>
              </div>
            ))}
          </div>
          <p style={{ textAlign: "center", marginTop: 48, fontSize: 22, fontWeight: 700, color: "#210875", lineHeight: 1.4 }}>
            J'ai vécu chacune de ces situations.<br/>
            <span style={{ color: "#E8A87C" }}>C'est exactement pour ça que Biz360 existe.</span>
          </p>
        </div>
      </section>

      {/* ============ MON HISTOIRE ============ */}
      <section style={{ padding: "90px 24px", background: "linear-gradient(180deg, #FBF6EF 0%, #F3EEFF 100%)" }}>
        <div style={{ maxWidth: 900, margin: "0 auto", display: "grid", gridTemplateColumns: "1fr 1.4fr", gap: 60, alignItems: "center" }}>
          <div style={{ background: "#E8A87C", aspectRatio: "3/4", borderRadius: 20, boxShadow: "0 20px 60px rgba(33,8,117,.20)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 64, color: "#fff" }}>
            📸<br/>
            <span style={{ fontSize: 14, marginTop: 8, fontWeight: 600 }}>[Ta photo]</span>
          </div>
          <div>
            <p style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: 13, letterSpacing: "0.15em", textTransform: "uppercase", color: "#897FCB", fontWeight: 600, margin: "0 0 12px" }}>
              Mon histoire
            </p>
            <h2 style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: 32, lineHeight: 1.15, fontWeight: 800, letterSpacing: "-0.02em", margin: "0 0 24px" }}>
              J'ai galéré. Longtemps. Toute seule.
            </h2>
            <p style={{ fontSize: 17, lineHeight: 1.6, color: "#3a2e6b", margin: "0 0 16px" }}>
              Quand j'ai lancé mon activité, je pensais que le plus dur, ça serait de trouver des clients. En fait, non. Le plus dur, c'est <strong>tout le reste</strong>. La compta. Les taxes. Les seuils. Les échéances. Le jargon.
            </p>
            <p style={{ fontSize: 17, lineHeight: 1.6, color: "#3a2e6b", margin: "0 0 16px" }}>
              Aucun outil ne me parlait comme à un humain. Trop de features. Trop de menus. Trop de trucs pour «&nbsp;les vraies entreprises&nbsp;». Moi je voulais juste savoir <em>combien je dois</em>, <em>quand</em>, et <em>si je suis dans les clous</em>.
            </p>
            <p style={{ fontSize: 17, lineHeight: 1.6, color: "#3a2e6b", margin: "0 0 16px" }}>
              Alors j'ai construit <strong>Biz360</strong>. Pas pour faire du business. Pour arrêter de galérer. Et pour ne plus jamais me sentir seule face à mon relevé bancaire.
            </p>
            <p style={{ fontSize: 17, lineHeight: 1.6, color: "#3a2e6b", margin: "0 0 20px", fontStyle: "italic" }}>
              Aujourd'hui, il est prêt. Et je te tends la main.
            </p>
            <p style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontWeight: 800, fontSize: 20, color: "#210875", margin: 0 }}>
              — Tiphaine ✍️
            </p>
          </div>
        </div>
      </section>

      {/* ============ CE QUE TU AURAS ============ */}
      <section style={{ background: "#fff", padding: "90px 24px" }}>
        <div style={{ maxWidth: 1000, margin: "0 auto" }}>
          <p style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: 13, letterSpacing: "0.15em", textTransform: "uppercase", color: "#897FCB", fontWeight: 600, margin: "0 0 16px", textAlign: "center" }}>
            Ce que tu auras
          </p>
          <h2 style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: 40, lineHeight: 1.15, fontWeight: 800, letterSpacing: "-0.02em", margin: "0 0 60px", textAlign: "center" }}>
            Fini de galérer seule.<br/>
            <span style={{ color: "#E8A87C" }}>Voici comment je te tiens la main.</span>
          </h2>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 24 }}>
            {[
              { emo: "📊", titre: "Un tableau de bord qui te dit ce qui compte", desc: "CA du mois, cotisations Urssaf déjà calculées, seuils TVA en direct, alertes automatiques 10 jours avant chaque échéance. Fini Excel." },
              { emo: "🧠", titre: "Zéro calcul dans ta tête", desc: "Biz360 calcule tout à ta place : ce que tu dois à l'Urssaf, ta marge, ton bénéfice net, l'impact d'une nouvelle vente. Tu regardes, c'est tout." },
              { emo: "⚡", titre: "Des alertes qui te préviennent AVANT le drame", desc: "« Tu approches ton seuil TVA », « Ta déclaration Urssaf est dans 8 jours », « Tu n'as pas encaissé la facture X depuis 45 jours ». Toi tu vis tranquille." },
              { emo: "💬", titre: "Moi, joignable directement par mail", desc: "T'as une question ? Tu m'écris. C'est moi qui te réponds, en moins de 24h. Pas un chatbot. Pas un support anonyme. Une auto-entrepreneure qui a vécu ta situation." },
              { emo: "📚", titre: "Mon guide 2027 offert", desc: "Le guide sur l'e-facturation obligatoire (16 pages, normalement 9€) — offert dès ton inscription. Pour comprendre ce qui t'attend, sans jargon." },
              { emo: "🆘", titre: "SOS express -30% en cas de crise", desc: "Un truc te dépasse ? Réserve un appel de 1h avec moi à 16€ (au lieu de 25€) en tant qu'abonnée. On débloque ensemble." },
            ].map((item, i) => (
              <div key={i} style={{ background: "#FBF6EF", padding: "28px 24px", borderRadius: 16, border: "1px solid #E5DEFF" }}>
                <div style={{ fontSize: 38, marginBottom: 12 }}>{item.emo}</div>
                <h3 style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: 18, fontWeight: 800, margin: "0 0 10px", color: "#210875" }}>{item.titre}</h3>
                <p style={{ margin: 0, fontSize: 14.5, lineHeight: 1.55, color: "#3a2e6b" }}>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ============ LA VRAIE DIFFERENCE ============ */}
      <section id="communaute" style={{ padding: "90px 24px", background: "#210875", color: "#fff", position: "relative" }}>
        <div style={{ maxWidth: 780, margin: "0 auto", textAlign: "center" }}>
          <p style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: 13, letterSpacing: "0.15em", textTransform: "uppercase", color: "#E8A87C", fontWeight: 600, margin: "0 0 16px" }}>
            La vraie différence
          </p>
          <h2 style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: 42, lineHeight: 1.15, fontWeight: 800, letterSpacing: "-0.02em", margin: "0 0 32px" }}>
            Freebe, Indy, Abby, Pennylane…<br/>
            <span style={{ color: "#E8A87C" }}>ce sont des boîtes tech.</span><br/>
            Biz360, <span style={{ color: "#E8A87C" }}>c'est moi.</span>
          </h2>
          <p style={{ fontSize: 18, lineHeight: 1.6, opacity: 0.92, margin: "0 0 24px" }}>
            Chez les autres, tu ouvres un ticket, tu attends 3 jours, tu tombes sur un support anonyme qui te lit une FAQ.
          </p>
          <p style={{ fontSize: 18, lineHeight: 1.6, opacity: 0.92, margin: "0 0 40px" }}>
            Chez moi, tu m'écris, et je te réponds — moi, personnellement, en 24h. Parce que je suis toute seule aussi. Parce que je sais ce que c'est.
          </p>
          <Link to="/subscription" style={{ display: "inline-block", background: "#E8A87C", color: "#210875", padding: "20px 44px", borderRadius: 14, textDecoration: "none", fontFamily: "'Plus Jakarta Sans', sans-serif", fontWeight: 800, fontSize: 18 }}>
            Essayer 30 jours gratuits →
          </Link>
          <p style={{ marginTop: 16, fontSize: 13, opacity: 0.7 }}>Sans CB · Sans engagement</p>
        </div>
      </section>

      {/* ============ TARIFS SIMPLES ============ */}
      <section style={{ padding: "90px 24px", background: "#FBF6EF" }}>
        <div style={{ maxWidth: 780, margin: "0 auto", textAlign: "center" }}>
          <p style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: 13, letterSpacing: "0.15em", textTransform: "uppercase", color: "#897FCB", fontWeight: 600, margin: "0 0 16px" }}>
            Tarifs
          </p>
          <h2 style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: 40, lineHeight: 1.15, fontWeight: 800, letterSpacing: "-0.02em", margin: "0 0 24px" }}>
            Un prix. <span style={{ color: "#E8A87C" }}>Tout inclus.</span>
          </h2>
          <p style={{ fontSize: 17, lineHeight: 1.5, color: "#3a2e6b", margin: "0 0 48px" }}>
            Moins cher qu'une facture de comptable. Sans engagement. 30 jours d'essai sans carte bancaire — <em>tu ne payes que si tu restes.</em>
          </p>
          <div style={{ background: "#fff", padding: "48px 36px", borderRadius: 20, boxShadow: "0 20px 60px rgba(33,8,117,.12)", textAlign: "left" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 24, flexWrap: "wrap", gap: 12 }}>
              <div>
                <p style={{ margin: 0, fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: 24, fontWeight: 800, color: "#210875" }}>Abonnement Biz360</p>
                <p style={{ margin: "4px 0 0", fontSize: 14, color: "#897FCB" }}>Sans engagement · Résiliable en 1 clic</p>
              </div>
              <div style={{ textAlign: "right" }}>
                <p style={{ margin: 0, fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: 44, fontWeight: 800, color: "#210875", letterSpacing: "-0.02em" }}>12€<span style={{ fontSize: 18, color: "#897FCB", fontWeight: 500 }}>/mois</span></p>
                <p style={{ margin: "4px 0 0", fontSize: 13, color: "#E8A87C", fontWeight: 600 }}>ou 99€/an → 3 mois offerts 🎁</p>
              </div>
            </div>
            <ul style={{ listStyle: "none", padding: 0, margin: "24px 0 32px" }}>
              {[
                "📊 L'app Biz360 complète (CA, TVA, Urssaf, alertes)",
                "⚡ Alertes automatiques avant chaque échéance",
                "💬 Mon email direct — je te réponds sous 24h",
                "📚 Guide e-facturation 2027 offert (valeur 9€)",
                "🆘 SOS 1-to-1 à tarif préférentiel (16€ au lieu de 25€)",
                "🎁 30 jours d'essai gratuits — sans CB",
              ].map((line, i) => (
                <li key={i} style={{ padding: "10px 0", borderBottom: i < 5 ? "1px solid #F3EEFF" : "none", fontSize: 15, color: "#3a2e6b" }}>{line}</li>
              ))}
            </ul>
            <Link to="/subscription" data-testid="pricing-cta" style={{ display: "block", background: "#210875", color: "#fff", padding: "18px", borderRadius: 12, textDecoration: "none", fontFamily: "'Plus Jakarta Sans', sans-serif", fontWeight: 800, fontSize: 17, textAlign: "center" }}>
              Essayer 30 jours gratuits →
            </Link>
            <p style={{ margin: "16px 0 0", fontSize: 13, color: "#897FCB", textAlign: "center" }}>
              Une question avant ? <a href="mailto:t.samblat@gmail.com" style={{ color: "#E8A87C", fontWeight: 600 }}>Écris-moi directement</a>
            </p>
          </div>
        </div>
      </section>

      {/* ============ CTA FINAL ============ */}
      <section style={{ padding: "80px 24px", background: "#fff", textAlign: "center" }}>
        <div style={{ maxWidth: 700, margin: "0 auto" }}>
          <h2 style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: 36, lineHeight: 1.15, fontWeight: 800, letterSpacing: "-0.02em", margin: "0 0 20px" }}>
            Encore une hésitation ?
          </h2>
          <p style={{ fontSize: 18, lineHeight: 1.6, color: "#3a2e6b", margin: "0 0 32px" }}>
            Écris-moi. Je te réponds moi-même à <a href="mailto:t.samblat@gmail.com" style={{ color: "#210875", fontWeight: 600 }}>t.samblat@gmail.com</a>.<br/>
            Et si t'as vraiment envie de discuter en visio, prends 1h de <Link to="/subscription#sos" style={{ color: "#210875", fontWeight: 600 }}>SOS à 25€</Link>. C'est ma spécialité de débloquer les gens.
          </p>
          <Link to="/subscription" style={{ display: "inline-block", background: "#210875", color: "#fff", padding: "18px 40px", borderRadius: 14, textDecoration: "none", fontFamily: "'Plus Jakarta Sans', sans-serif", fontWeight: 800, fontSize: 17 }}>
            Essayer 30 jours gratuits →
          </Link>
        </div>
      </section>

      {/* ============ FOOTER ============ */}
      <footer style={{ padding: "40px 24px", background: "#FBF6EF", textAlign: "center", fontSize: 13, color: "#897FCB" }}>
        <p style={{ margin: "0 0 8px" }}>Biz360 ❤️‍🔥 — Édité par Tiphaine SAMBLAT — SIREN 913 345 682</p>
        <p style={{ margin: 0 }}>
          <Link to="/mentions-legales-cgu" style={{ color: "#897FCB", marginRight: 12 }}>Mentions légales</Link> ·
          <Link to="/cgv" style={{ color: "#897FCB", margin: "0 12px" }}>CGV</Link> ·
          <Link to="/politique-confidentialite" style={{ color: "#897FCB", marginLeft: 12 }}>Confidentialité</Link>
        </p>
      </footer>
    </div>
  );
}
